var _defs, _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 301 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fad414;\n      }\n\n      .st1 {\n        fill: #462ee9;\n      }\n\n      .st2 {\n        fill: #fe42ff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 113.9,
    y: -62.5,
    width: 78.8,
    height: 283.9,
    rx: 37,
    ry: 37,
    transform: "translate(39.3 209.1) rotate(-76.1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.5,38.7h0C14.7,17.3,36.3,4.3,57.6,9.5l198.7,48.8c21.3,5.2,34.4,26.8,29.2,48.1h0c-5.2,21.3-26.8,34.4-48.1,29.2L38.6,86.8c-21.3-5.2-34.4-26.8-29.2-48.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "86.4 53.6 62.9 47.8 64.9 39.7 55.7 37.4 49.9 60.9 59.1 63.2 61.2 54.8 84.7 60.6 82.6 69 91.8 71.2 97.6 47.7 88.4 45.5 86.4 53.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.3,58.2c-3-1.8-7.2-3.3-12.5-4.6s-9.8-1.9-13.2-1.7c-3.5,0-6.2.9-8.2,2.4-1.9,1.5-3.2,3.6-3.9,6.3-.7,2.7-.5,5.2.5,7.4s3.1,4.2,6.1,5.9c3,1.7,7.2,3.3,12.5,4.6s9.8,1.9,13.2,1.8c3.5-.2,6.2-1,8.1-2.4,2-1.5,3.3-3.6,3.9-6.4.7-2.7.5-5.2-.6-7.4-1-2.2-3-4.2-6.1-5.9h.2ZM134.1,69.1c-.5,1.5-1.2,2.5-2.4,3s-2.8.7-4.7.6c-1.9-.2-4.1-.5-6.6-1.2-2.5-.6-4.7-1.3-6.5-2.1-1.8-.8-3.2-1.7-4-2.7-.9-1.1-1.1-2.3-.7-3.8.4-1.5,1.2-2.5,2.4-3,1.3-.5,2.9-.7,4.9-.6,2,.2,4.2.5,6.8,1.2,2.5.6,4.7,1.3,6.4,2.1,1.8.7,3,1.6,3.9,2.7.8,1,.8,1.9.6,3.4v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.2,87.1c-.2-1.3-.4-2.1-1.3-3.2-.9-1.2-2.2-2.3-4-3.2-1.8-1-4-1.8-6.8-2.5-2.4-.6-4.5-.8-6.2-.8s-3.3.3-4.6.8-2.3,1-3.1,1.7-1.3,1.4-1.7,2.1-.6,1.3-.7,1.9l8.6,2.1c.2-.2.4-.4.8-.7.4-.2.9-.3,1.7-.4.8,0,1.9,0,3.3.5,1.9.5,3.2,1,4,1.7.8.6,1.1,1.5.8,2.6-.2.9-.8,1.5-1.8,1.8-.9.2-2.4,0-4.5-.4l-5-1.2-1.4,5.5,8.4,2.1c2.1.5,4,.7,5.9.4,1.9-.2,3.5-.8,4.8-1.9,1.3-1,2.3-2.5,2.7-4.4.3-1.4.4-2.8.2-4.1v-.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "191.2 90.1 187 69.7 175.9 67 162.7 83.2 157.9 62.5 147.5 60 154.9 86.7 167.3 89.8 179.7 75.5 184 93.9 196.4 96.9 215.2 76.6 205 74.1 191.2 90.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 223,
    y: 96.4,
    width: 5.7,
    height: 9.6,
    transform: "translate(73.7 296.4) rotate(-76.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHow2);
export default __webpack_public_path__ + "static/media/how-2.f6d57506fa397cdeaf4c9303a180a479.svg";
export { ForwardRef as ReactComponent };